import { render, staticRenderFns } from "./AppccTopDetail.vue?vue&type=template&id=3b4303a7"
import script from "./AppccTopDetail.vue?vue&type=script&lang=js"
export * from "./AppccTopDetail.vue?vue&type=script&lang=js"
import style0 from "./AppccTopDetail.vue?vue&type=style&index=0&id=3b4303a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports